// extracted by mini-css-extract-plugin
export default {"grey500":"#9e9e9e","danger":"#f13a42","danger50":"#feebef","danger100":"#fcccd4","danger300":"#e17079","clear":"Custom_clear__yWU-c","heart":"Custom_heart__VyZF9"};